// @flow
import BaseComponent from '../base_component/base_component'

export default class Hero extends BaseComponent {

    constructor(id: number, component_name: string) {
        super(id, component_name);
        this.addAndRemoveBackground();
        this.overrideLoginBehaviour();
    }

    // Captures the ?r= param.
    overrideLoginBehaviour() {
      let $form = $(this.component).find('#login-form')
      let redirectString = this._getRedirectString();
      $form.submit((event: JQueryEventObject) => {
        if (!redirectString) return;

        $form.attr('action', `/login?r=${redirectString}`);
      })
    }

    _getRedirectString(): ?string {
      let match = window.location.href.match(/[\?&]r=([^$\&]*)/);
      return match ? match[1] : null;
    }

    scrollTo(target: string) {
      let $target = $(`#${target}`);
      if ($target.length === 0) {
        return window.location.href = `/landing_page#${target}`
      }
      $('html, body').animate({
        scrollTop: $target.offset().top
      }, 'slow');
      return false;
    }

    addAndRemoveBackground() {
      $(window).scroll( function (event) {
        if ($(window).scrollTop() > 50) {
            $('.nimbus-securities-logo').addClass('logo-shrink');
            $('.hero-login-mobile').addClass('logo-shrink');
            $('.header-fixed').css({'position': 'fixed', 'background':'#eea200', 'transition':'0.5s'});
        } else {
          $('.nimbus-securities-logo').removeClass('logo-shrink');
          $('.hero-login-mobile').removeClass('logo-shrink');
          $('.header-fixed').css({'position': 'fixed', 'background': '', 'z-index': '', 'transition': ''});
        };
      });
    }

     showLogin() {
      if ($('#about').length === 0) {
        return window.location.href = `/landing_page#home`
      }
      $(this.component).find('.hero-login').attr('style', '');
      this.scrollTo('home');
    }

    showForm(name: string) {
        $(this.component).find('#login-form').toggleClass('hidden', name === 'reset');
        $(this.component).find('#reset-password-form').toggleClass('hidden', name === 'login');
        $(this.component).find('.submitted-message').addClass('hidden');
        return false;
    }

    resetPassword() {
        $.post('/resend_email', $('#reset-password-form').serialize(), () => {
            $(this.component).find('#reset-password-form').addClass('hidden');
            $('.submitted-message').removeClass('hidden');
        });
        return false;
    }
}